import type { SiteLanguage } from "@/lib/site-data";

/**
 * Formatting a date with `toLocaleString()` on a server component is a
 * classic hydration-mismatch source: the Node runtime picks en-GB-ish
 * defaults, the browser picks the user's OS locale. We already know the
 * UI language for any given view, so format with an explicit BCP 47 tag
 * and a fixed UTC time zone — output is identical on server and client.
 */

const LOCALE_BY_SITE_LANGUAGE: Record<SiteLanguage, string> = {
  en: "en-GB",
  tr: "tr-TR",
  de: "de-DE",
  uk: "uk-UA",
};

export function resolveDateLocale(language: SiteLanguage): string {
  return LOCALE_BY_SITE_LANGUAGE[language] ?? "en-GB";
}

export function formatDateTime(
  value: string | number | Date,
  language: SiteLanguage,
  options: Intl.DateTimeFormatOptions = {},
): string {
  return new Intl.DateTimeFormat(resolveDateLocale(language), {
    timeZone: "UTC",
    dateStyle: "short",
    timeStyle: "short",
    ...options,
  }).format(new Date(value));
}

export function formatDate(
  value: string | number | Date,
  language: SiteLanguage,
  options: Intl.DateTimeFormatOptions = {},
): string {
  return new Intl.DateTimeFormat(resolveDateLocale(language), {
    timeZone: "UTC",
    dateStyle: "short",
    ...options,
  }).format(new Date(value));
}
